import React from "react"
import { Col, Input, Row, Table } from "reactstrap"

export default function DetailTable({ config }) {
  const {
    handleInput,
    setProductModalShown,
    productTableData,
    handleModalShow,
  } = config
  return (
    <Table bordered>
      <thead>
        <tr className="text-center">
          <th style={{ width: 215 }}> RTW商品番号 </th>
          <th> 商品名 </th>
          <th> 単価 </th>
          <th style={{ width: 85 }}> 数 </th>
          <th style={{ width: 205 }}> 割引 </th>
          <th style={{ width: 145 }}> 合計金額 </th>
        </tr>
      </thead>

      <tbody>
        {productTableData &&
          productTableData.map((item, idx) => (
            <DetailRow
              key={idx}
              showModal={setProductModalShown}
              data={item}
              handleModalShow={handleModalShow}
              idx={idx}
              handleInput={handleInput}
            />
          ))}
        <LastRow data={productTableData} />
      </tbody>
    </Table>
  )
}

export function DetailRow(props) {
  const { handleInput, handleModalShow, data, idx } = props
  const {
    discount,
    productNumber,
    productName,
    totalAmount,
    unitPrice,
    number,
  } = data

  return (
    <tr>
      <td>
        <Input
          onClick={() => handleModalShow(idx)}
          type="text"
          value={productNumber}
          placeholder=""
          readOnly
        />
      </td>
      <td>{productName}</td>
      <td>{unitPrice || ""}</td>
      <td>
        <Input
          type="number"
          defaultValue={number}
          onChange={e => handleInput({ e, type: "number", idx })}
          min={0}
          disabled={!productNumber}
          className="text-end"
        />
      </td>
      <td>
        <Row>
          <Col sm={5}>
            <Input
              type="select"
              name="discountType"
              disabled={!productNumber}
              onChange={e => handleInput({ e, type: "discountType", idx })}
            >
              <option value="%">%</option>
              <option value="円">円</option>
            </Input>
          </Col>
          <Col sm={7}>
            <Input
              type="text"
              name="discountAmount"
              defaultValue={discount}
              onChange={e => handleInput({ e, idx, type: "discountAmount" })}
              className="text-end"
              disabled={!productNumber}
              min={0}
            />
          </Col>
        </Row>
      </td>
      <td>
        <Input
          type="text"
          className="text-end"
          value={totalAmount.toLocaleString("ja-JP")}
          readOnly
          disabled
        />
      </td>
    </tr>
  )
}

export function LastRow({ data }) {
  const sum = data.reduce((acc, val) => acc + val.totalAmount, 0)
  return (
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <th className="text-center">合計</th>
      <th className="text-end">{sum.toLocaleString("ja-JP")}</th>
    </tr>
  )
}
